import { FilterableEntity } from "gql/graphql";
import { MetaFilter } from "@/shared/filters-by-meta";
import { Alert } from "@/shared/feedback/alert";
import Spin from "@/shared/feedback/spin";
import { useDocumentsTranslations } from "@/modules/documents/shared/utils/use-documents-translations";
import { CompanyDocumentParticipantsSummary } from "@/modules/documents/widgets/company-document-participants-summary";
import { CompanyDocumentAnalytics } from "@/modules/documents/widgets/company-document-statistic";
import { CompanyDocumentAnalyticsOptions } from "@/modules/documents/widgets/company-document-analytics-options";
import { CreateCompanyDocumentConfirmationMenu } from "@/modules/documents/widgets/create-company-document-confirmation-menu";
import { NotifyToReadDocumentButton } from "@/modules/documents/features/notify-to-read-document";
import { useCompanyDocumentReadConfirmationType } from "../model/use-company-document-read-confirmation-type";

export function CompanyDocumentParticipants({ id }: { id: string }) {
  const t = useDocumentsTranslations();
  const { readConfirmationType, canAssign } =
    useCompanyDocumentReadConfirmationType(id);

  if (!readConfirmationType) {
    return <Spin />;
  }

  if (!canAssign) {
    return (
      <Alert
        showIcon
        type="info"
        message={t("Read confirmation is not required")}
        description={t("Read confirmation is not required hint")}
      />
    );
  }

  return (
    <div className="grid gap-5">
      <CompanyDocumentParticipantsSummary id={id} />

      <MetaFilter
        filterableEntity={FilterableEntity.CommonDocumentReadConfirmationPerson}
        primary={"personName"}
      >
        <div className="flex flex-wrap items-start gap-2">
          <div className="grow basis-72">
            <MetaFilter.Controls />
          </div>

          <div className="flex flex-wrap gap-2">
            <CreateCompanyDocumentConfirmationMenu documentId={id} />
            <NotifyToReadDocumentButton id={id} />
          </div>
        </div>

        <CompanyDocumentAnalytics
          id={id}
          Options={CompanyDocumentAnalyticsOptions}
        />
      </MetaFilter>
    </div>
  );
}
